import React, { useState } from "react";
import { toast } from "react-toastify";

type Props = {
  title: string;
  description?: React.ReactNode;
  confirmLabel?: string;
  onClose: () => void;
  /** Recebe o motivo já sem espaços nas pontas; rejeitar mantém o modal aberto. */
  onConfirm: (reason: string) => Promise<void>;
};

/** Pede um motivo (mín. 3 caracteres) antes de uma ação que cancela algo. */
export default function ReasonModal({ title, description, confirmLabel = "Confirmar", onClose, onConfirm }: Props) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (reason.trim().length < 3) return toast.error("Informe o motivo (mínimo de 3 caracteres).");
    setSaving(true);
    try {
      await onConfirm(reason.trim());
    } catch (error: any) {
      toast.error(error?.message || "Erro ao salvar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dpModalOverlay">
      <div className="dpModal">
        <header className="dpModal__header">
          <h2 className="dpModal__title">{title}</h2>
          <button className="dpModal__close" onClick={onClose} disabled={saving}>
            &times;
          </button>
        </header>
        <div className="dpModal__body">
          {description ? <p className="dpNotice">{description}</p> : null}
          <div className="dpFormGroup">
            <label htmlFor="reasonText">Motivo *</label>
            <textarea
              id="reasonText"
              className="dpTextarea"
              maxLength={500}
              value={reason}
              disabled={saving}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
        <footer className="dpModal__footer">
          <button type="button" className="dpBtn dpBtn--secondary" onClick={onClose} disabled={saving}>
            Voltar
          </button>
          <button type="button" className="dpBtn dpBtn--danger" onClick={submit} disabled={saving}>
            {saving ? "Salvando..." : confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
}
